module.exports = __webpack_public_path__ + "media/images/brand/app_logo_full-98bfe26df26d50b9818ccd87213d66d1.png";